import { Span } from '@opentelemetry/api';

export default class SpanRegistrar {
  private readonly spans: Record<string, Span> = {};

  getSpan(name: string): Span | undefined {
    return this.spans[name];
  }

  isSpanRegistered(name: string): boolean {
    return Boolean(this.spans[name]);
  }

  registerSpan(name: string, span: Span): void {
    if (this.isSpanRegistered(name)) {
      throw new Error(`cannot replace existing span ${name}`);
    }
    const origEnd = span.end.bind(span);
    span.end = (endTime) => {
      origEnd(endTime);
      this.unregisterSpan(name);
    };
    this.spans[name] = span;
  }

  unregisterSpan(name: string): void {
    delete this.spans[name];
  }
}
